import i18n from '@dms/i18n';
import {useCountry} from '@dms/shared';

import {Field} from './primitives/Field';

export function FirstRegistrationCountrySelect() {
  const {sortedCountriesOptions} = useCountry();

  return (
    <Field
      type="choice"
      name="firstRegistrationCountry"
      label={i18n.t('entity.vehicle.labels.firstRegistrationCountry')}
      options={sortedCountriesOptions ?? []}
    />
  );
}
